import React from "react";
import { data } from "./Data";

const OurWork = () => {
  return (
    <div className="our-work-container">
        <h1 className="heading">Flagship Projects </h1>
      {data.map((value, index) => (
        <details key={index} className="our-work-item">
          <summary>{value.title}</summary>
          <div
            className="our-work-desc"
            dangerouslySetInnerHTML={{ __html: value.desc }}
          />
        </details>
      ))}
    </div>
  );
};

export default OurWork;